import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import trTranslations from './locales/tr.json';
import enTranslations from './locales/en.json';

// localStorage'dan dil tercihini al
const getStoredLanguage = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('app_language') || 'tr';
  }
  return 'tr';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      tr: {
        translation: trTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    lng: getStoredLanguage(),
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false, // React zaten XSS koruması sağlıyor
    },
  });

// Dil değiştiğinde localStorage'a kaydet
i18n.on('languageChanged', (lng) => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('app_language', lng);
  }
});

export default i18n;
